/*eslint-disable */
const $ = window.jQuery = require('jquery');

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import mobileMenuBar from '../mobileMenuBar/';

export default {
  name: 'lymphomap-header',
  components: {
    mobileMenuBar
  },
  props: [],
  data () {
    return {
      showBtn:true,
      is_superuser:Boolean,
      is_admin:Boolean,
      userRoleType:'',
      isMobile:false,
      selfUserInfo:null,
      accessFeaturesOfPackageState:false,
      notificationBadgeInfo:null,
      schatCount:0
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getUserDetailsAgainFun(){
      this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data;
      return;
    },
    getReqNotificationCountMethod(){
      return this.$store.getters.workspaceUserNotificationGetters;
    }
  },
  mounted () {
    // bus.$on('selfUserUpdateStatus', (data) => {
    //   if(window.location.pathname.indexOf('supportWorkspace') == -1) {
    //     this.schatCount = data.supportUnreadCount;
    //   }
    // });
    // bus.$on('updateMessageNotifications', (data) => {
    //   if(window.location.pathname.indexOf('supportWorkspace') == -1) {
    //     if(data.supportUnreadCount > 0){
    //       if(Push.Permission.has()){
    //         Push.create(data.senderName, {
    //           body:data.message,
    //           timeout:4000,
    //           onClick: function () {
    //               window.focus();
    //               this.close();
    //           }
    //         })
    //         this.schatCount = data.supportUnreadCount;
    //       }else{
    //         this.schatCount = data.supportUnreadCount;
    //         this.playSound(audioPlay);
    //       }
    //     }
    //   }
    // });
    bus.$on('clearSChatCountBus', (data) => {
      this.schatCount = data;
    });
    bus.$on('showHeaderbtn', (data) => {
      this.showBtn = data;
    });
    this.$store.dispatch('fetchCurrentUserInfo').then((res)=>{
      this.is_superuser = res.data.data.is_superuser;
      this.userRoleType = res.data.data.user_type;
      this.is_admin = res.data.data.is_admin;
    })
    bus.$on('clearNotificationBadgeInfo', (data) => {
      this.notificationBadgeInfo = data;
    });
  },
  methods: {
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    onResize () {
      this.isMobile = window.innerWidth < 769;
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      let covid_19_popup = document.querySelector(".covid_19_popup");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
        if(covid_19_popup){
          covid_19_popup.classList.add('moved_to_top_icon');
        }
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
          if(covid_19_popup){
          covid_19_popup.classList.remove('moved_to_top_icon');
          }
        }
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logoutAction')
      .then(() => {
        this.logOutUser()
        window.location.href = '/';
      })
    },
    homeRedircet(){
      window.location.href = '/';
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
}
